module.exports = __webpack_public_path__ + "img/agriculture/square_icon2.2635fd51.png";